module.exports = __webpack_public_path__ + "PSillustration.webp?400f9d427ee632139bb18c43d0d397ee";